import {createFileRoute} from '@tanstack/react-router'

import {zeroLevelIndexRoute} from "../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg/browse/')({
    ...zeroLevelIndexRoute("/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});

